import styled, { css } from 'styled-components'
import { desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'
import Blink from '@components/Blink'

const TeaserMiddleToiWrapper = styled(Blink)`
  ${({
    theme: {
      measures: {
        outerPadding: { mobile: mobilePadding, tablet: tabletPadding },
      },
    },
  }) => css`
    text-decoration: none;
    ${desktopCSS(css`
      display: none;
    `)}

    ${mobileCSS(css`
      max-width: calc(100vw - 2 * ${mobilePadding});
    `)}
    ${tabletCSS(css`
      max-width: calc(100vw - 2 * ${tabletPadding});
    `)}
  `}
`

export default TeaserMiddleToiWrapper
